import {NOTIFICATION_PER_PAGE} from './'

export function getNotifyNumber(state) {
  return state.notifications.total || 0
}

export function getNotifyList(state) {
  return state.notifications.data || []
}
export function getNotifySetupList(state) {
  return state.notifications.data_setup || []
}
export function getNotifyPageCount(state) {
  return Math.ceil(state.notifications.total / NOTIFICATION_PER_PAGE)
}

export function getNotifyPageCurrent(state) {
  return state.notifications.currentPage
}



// WEBPACK FOOTER //
// ./client/redux/modules/notifications/selectors.js